// type Api = {
//     Trips: {
//         TripId: number,
//         IsActive: boolean,
//         // ...general info
//         Addresses: [
//             {
//                 AddressId: string,
//                 TripId: number,
//                 // ...general info
//                 Tasks: [
//                     {
//                         TaskId: string,
//                         AddressId: string,
//                         TripId: number,
//                     },
//                 ],
//             }
//         ],
//     },
// };

import {mdiTimer} from "@mdi/js";

export type TotalMinutesAndDistanceType = { Min: number, Km: number };

export enum Languages {
    Latvian = 'lv',
    English = 'en',
    German = 'de',
    Russian = 'ru',
    Lithuanian = 'lt',
    Estonian = 'ee',
    French = 'fr',
    Danish = 'dk',
}

export enum ColorModes {
    auto = 'auto',
    light = 'light',
    dark = 'dark',
}

export type Screen = {
    width: number,
    height: number,
}

export type ValidationFeedback = {
    type: FeedbackType | null,
    text: string,
}

export enum FeedbackType {
    Error = 'Error',
    Success = 'Success',
    Warning = 'Warning',
    Info = 'Info',
}

export type Paddings = {
    xs: number,
    s: number,
    m: number,
    l: number,
}

export type Company = {
    Name: string,
    VatNumber: string,
}

export type Toast = {
    type: ToastType,
    title: string,
    text: string,
    iconPath: typeof mdiTimer,
}

export enum ToastType {
    Primary = 'primary',
    Success = 'success',
    Danger = 'danger',
    Warning = 'warning',
    Info = 'info',
    Light = 'light',
    Dark = 'dark',
}

export enum ApiSliceStatus {
    Idle = 'idle',
    Loading = 'loading',
    Succeeded = 'succeeded',
    Failed = 'failed',
}

export enum FieldRequireType {
    Required = 'Required',
    Optional = 'Optional',
    NotRequired = 'NotRequired',
}

export enum fieldType {
    date = 'date',
    // number = 'number',
    select = 'select',
    // text = 'text',
}